import { Box, Typography } from '@mui/material';
import { analyticsColors } from './analyticsStyles';

interface Props {
  label: string;
  value: string | number;
  icon: React.ReactNode;
}

export const CustomerKpiCard = ({ label, value, icon }: Props) => (
  <Box
    sx={{
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 1,
      px: 2,
      py: 1.5,
      minHeight: 88,
      height: '100%',
      width: '100%',
      bgcolor: analyticsColors.cardBg,
      border: `1px solid ${analyticsColors.cardBorder}`,
      borderRadius: '12px',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 1,
        width: '100%',
      }}
    >
      <Typography
        sx={{
          fontSize: '0.6875rem',
          fontWeight: 600,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: analyticsColors.metricLabel,
          lineHeight: 1.3,
          pr: 0.5,
        }}
      >
        {label}
      </Typography>

      <Box
        sx={{
          width: 34,
          height: 34,
          minWidth: 34,
          borderRadius: '50%',
          bgcolor: analyticsColors.rankBg,
          color: analyticsColors.rankText,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '0.95rem',
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
    </Box>

    <Typography
      sx={{
        fontSize: { xs: '1.375rem', sm: '1.5rem' },
        fontWeight: 700,
        color: analyticsColors.metricValue,
        lineHeight: 1.1,
      }}
    >
      {value}
    </Typography>
  </Box>
);
